module.exports = __webpack_public_path__ + "static/media/Aalidhra11a2.5021a42b.jpg";